import React from "react";
import { Grid } from "@material-ui/core";
import Product from "./Product/Product";
import useStyle from "./Styles";

// const product = [
//   {
//     id: 1,
//     name: "Shoes",
//     description: "Running shoes",
//     price: "15$",
//     img: "https://i.pinimg.com/564x/61/c1/42/61c142b514960cbded9a8feb5ca97226.jpg",
//   },
//   {
//     id: 2,
//     name: "Macbook",
//     description: "Apple macbook",
//     price: "2.000$",
//     img: "https://i.pinimg.com/564x/24/c6/ec/24c6ec9b712e86f3d64b15ae64851ee8.jpg",
//   },
// ];

function Products({ products, onAddToCart }) {
  const classes = useStyle();

  return (
    <main style={{ marginTop: "60px" }} className={classes.content}>
      <div className={classes.toolbar}>
        <Grid container justify="center" spacing={4}>
          {products.map(product => (
            <Grid
              style={{ margin: "0 auto 5px" }}
              item
              key={product.id}
              xs={12}
              sm={6}
              md={4}
              lg={3}
            >
              <Product onAddToCart={onAddToCart} product={product} />
            </Grid>
          ))}
        </Grid>
      </div>
    </main>
  );
}

export default Products;
